module.exports = require("./fr-NC.js");